import { useEffect, useState } from "react";
import "./Navbar.css";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`navbar navbar-expand-lg custom-navbar ${scrolled ? "navbar-scrolled" : ""}`}>

      <div className="container">

        <a className="navbar-brand" href="#home">

          <div className="logo">

            <div className="logo-lines">
              <span></span>
              <span></span>
              <span></span>
            </div>

            <div className="logo-text">
              <h4>TIGI</h4>
              <small>Industries (I) Pvt. Ltd.</small>
            </div>

          </div>

        </a>

        <button
          className="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#navbarMenu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className="collapse navbar-collapse"
          id="navbarMenu"
        >

          <ul className="navbar-nav ms-auto">

            <li className="nav-item">
              <a className="nav-link" href="#about">
                About
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#products">
                Products
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#industries">
                Industries
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#contact">
                Contact
              </a>
            </li>

            <li className="nav-item ms-lg-3">

              <a
                href="#contact"
                className="btn quote-btn"
              >
                Request Quote
              </a>

            </li>

          </ul>

        </div>

      </div>

    </nav>
  );
}

export default Navbar;